import environment from "web/script/modules/environment";
import loader from "./loader";

const load = loader(() => {
    (function (f, b) {
        if (!b.__SV) {
            var e, g, i, h;
            window.mixpanel = b;
            b._i = [];
            b.init = function (e, f, c) {
                function g(a, d) {
                    var b = d.split(".");
                    2 == b.length && ((a = a[b[0]]), (d = b[1]));
                    a[d] = function () {
                        a.push([d].concat(Array.prototype.slice.call(arguments, 0)));
                    };
                }
                var a = b;
                "undefined" !== typeof c ? (a = b[c] = []) : (c = "mixpanel");
                a.people = a.people || [];
                a.toString = function (a) {
                    var d = "mixpanel";
                    "mixpanel" !== c && (d += "." + c);
                    a || (d += " (stub)");
                    return d;
                };
                a.people.toString = function () {
                    return a.toString(1) + ".people (stub)";
                };
                i =
                    "disable time_event track track_pageview track_links track_forms track_with_groups add_group set_group remove_group register register_once alias unregister identify name_tag set_config reset opt_in_tracking opt_out_tracking has_opted_in_tracking has_opted_out_tracking clear_opt_in_out_tracking start_batch_senders people.set people.set_once people.unset people.increment people.append people.union people.track_charge people.clear_charges people.delete_user people.remove".split(
                        " "
                    );
                for (h = 0; h < i.length; h++) g(a, i[h]);
                var j = "set set_once union unset remove delete".split(" ");
                a.get_group = function () {
                    function b(c) {
                        d[c] = function () {
                            call2_args = arguments;
                            call2 = [c].concat(Array.prototype.slice.call(call2_args, 0));
                            a.push([e, call2]);
                        };
                    }
                    for (
                        var d = {},
                            e = ["get_group"].concat(Array.prototype.slice.call(arguments, 0)),
                            c = 0;
                        c < j.length;
                        c++
                    )
                        b(j[c]);
                    return d;
                };
                b._i.push([e, f, c]);
            };
            b.__SV = 1.2;
            e = f.createElement("script");
            e.type = "text/javascript";
            e.async = !0;
            e.src =
                "undefined" !== typeof MIXPANEL_CUSTOM_LIB_URL
                    ? MIXPANEL_CUSTOM_LIB_URL
                    : "file:" === f.location.protocol &&
                      "//cdn.mxpnl.com/libs/mixpanel-2-latest.min.js".match(/^\/\//)
                    ? "https://cdn.mxpnl.com/libs/mixpanel-2-latest.min.js"
                    : "//cdn.mxpnl.com/libs/mixpanel-2-latest.min.js";
            g = f.getElementsByTagName("script")[0];
            g.parentNode.insertBefore(e, g);
        }
    })(document, window.mixpanel || []);

    window.mixpanel.init(environment.get("mixpanelToken"), {
        // Our Mixpanel projects are EU data-resident; session replay uses the same host.
        api_host: "https://api-eu.mixpanel.com",
        record_sessions_percent: 0,
        remote_settings_mode: "fallback",
        // Allowlist masking: everything is masked by default. Content is only revealed
        // where it opts in with the "mp-unmask" class: on the page body for content pages,
        // or on individual non-PII elements (e.g. in checkout). Anything untagged stays masked.
        record_mask_all_text: true,
        record_unmask_text_selector: [".mp-unmask"],
        // Inputs stay masked; the site search field is the one exception.
        record_mask_all_inputs: true,
        record_unmask_input_selector: ['input[type="search"][name="q"]'],
        // Show product imagery (default blocks "img, video"); keep video blocked.
        record_block_selector: "video",
        // Console output bypasses DOM masking and some errors carry request bodies.
        record_console: false,
    });
});

export default function () {
    load();
}
